export default {
  zero: '0',
  oneThird: '30%',
  half: '48%',
  twoThird: '60%',
  fourth: '80%',
  full: '100%',
};
